import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import DashAwareLines from '../charts/reproduction/DashAwareLines.js';
import '../charts/reproduction/NivoChartCard.css';
import './WeightLineChart.css';

const SCORE_COLOR = '#b8862f';

// pointSize is a flat number in this Nivo version (no per-series function),
// so hiding the zero-reference line's markers needs its own layer instead —
// same reasoning as DashAwareLines for per-series stroke dashing.
const ScorePointsOnly = ({ series }) => (
  <g>
    {series.find(s => s.id === 'Score')?.data.map((d, i) => (
      <circle key={i} cx={d.position.x} cy={d.position.y} r={4} fill={SCORE_COLOR} />
    ))}
  </g>
);

const formatLabel = (dateString) => {
  const d = new Date(dateString);
  if (isNaN(d)) return dateString;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${String(d.getFullYear()).slice(2)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const LotScoreChart = ({ points = [] }) => {
  if (points.length === 0) return null;

  const sorted = [...points].sort((a, b) => a.scored_at.localeCompare(b.scored_at));
  const dates = sorted.map(p => p.scored_at);

  const series = [
    { id: 'zero', color: '#ccc', dashed: true, data: dates.map(d => ({ x: d, y: 0 })) },
    { id: 'Score', color: SCORE_COLOR, data: sorted.map(p => ({ x: p.scored_at, y: p.score })) },
  ];

  const tickEvery = Math.max(1, Math.ceil(dates.length / 8));
  const tickValues = dates.filter((_, i) => i % tickEvery === 0);

  return (
    <div className="wlc-wrap">
      <div className="wlc-chart-wrap" style={{ height: 220 }}>
        <ResponsiveLine
          data={series}
          margin={{ top: 12, right: 16, bottom: 36, left: 40 }}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', nice: true }}
          axisBottom={{ tickValues, format: formatLabel, tickRotation: 0 }}
          colors={{ datum: 'color' }}
          lineWidth={2}
          useMesh={true}
          enableGridX={false}
          motionConfig="gentle"
          layers={['grid', 'axes', 'crosshair', DashAwareLines, ScorePointsOnly, 'slices', 'mesh']}
          theme={{
            axis: { ticks: { text: { fill: '#898781', fontSize: 11.5 } } },
            grid: { line: { stroke: '#e1e0d9', strokeWidth: 1 } },
          }}
          tooltip={({ point }) => (
            point.seriesId === 'zero' ? null : (
              <div className="nivo-tooltip">
                <span className="nivo-tooltip-swatch" style={{ background: SCORE_COLOR }} />
                <strong>{point.seriesId}</strong>: <span className="nivo-tooltip-value">{point.data.y}</span>
              </div>
            )
          )}
        />
      </div>
    </div>
  );
};

export default LotScoreChart;
